import React, { Suspense, lazy } from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import * as Rout from "../routes/Route";
import ScrollTop from "../Common/ScrollTop";
import Desktoplayout from "../layout/Desktoplayout";
// ✅ Lazy load route components
const Home = lazy(() => import("../../Views/Home"));
const WhoWeAre = lazy(() => import("../../Views/WhoWeAre"));
const Media = lazy(() => import("../../Views/Media"));
const Getinvolve = lazy(() => import("../../Views/Getinvolve"));
const Polices = lazy(() => import("../../Views/Polices"));
const Events = lazy(() => import("../../Views/Events"))
const PdfViewer = lazy(() => import("../Common/PdfViewer"))
const PdfViewer1 =lazy(()=> import("../Common/PdfViewer1"))
const Approute = () => {
  
  return (
    <Router>
         {/* <StartupModal />  */}
      <ScrollTop>
        <Suspense fallback={<div></div>}>
          <Routes>
            <Route
              path={Rout.Home}
              element={
                <Desktoplayout>
                  <Home />
                </Desktoplayout>
              }
            />
            <Route
              path={Rout.WhoWeAre}
              element={
                <Desktoplayout>
                  <WhoWeAre />
                </Desktoplayout>
              }
            />
            <Route
              path="/view-pdf"
              element={
                  <PdfViewer />
              }
            />
            <Route
              path="/bharat_Biodesign_pdf"
              element={
                  <PdfViewer1 />
              }
            />
            <Route
              path={Rout.Getinvolve}
              element={
                <Desktoplayout>
                  <Getinvolve />
                </Desktoplayout>
              }
            />
            <Route
              path={Rout.Polices}
              element={
                <Desktoplayout>
                  <Polices />
                </Desktoplayout>
              }
            />
            <Route
              path={Rout.Media}
              element={
                <Desktoplayout>
                  <Media />
                </Desktoplayout>
              }
            />
            <Route
              path={Rout.Events}
              element={
                <Desktoplayout>
                  <Events />
                </Desktoplayout>
              }
            />
          </Routes>
        </Suspense>
      </ScrollTop>
    </Router>
  );
};

export default Approute;
